import { TableCols } from "../interfaces/static-data";

export const LEGAL_ENTITY_COLS: TableCols[] = [
    {
        key: 'name',
        displayValue: 'Name',
    },
    {
        key: 'shortName',
        displayValue: 'Short Name'
    },
    {
      key: 'lastUpdatedBy',
      displayValue: 'Last Updated By',
      hideOnForm: true
    },
    {
      key: 'updatedOn',
      displayValue: 'Updated On',
      hideOnForm: true
    }
];

export type LegalEntity = {
    id: number;
    name: string;
    shortName: string;
}
